import { Link } from 'react-router-dom';

import avantagesImg from '@/assets/images/img_actu.png';
import memoImg from '@/assets/images/memo.png';
import parrainageImg from '@/assets/images/parrainage.png';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useContractsData } from '@/hooks/api/use-contracts';
import { hasOtherContract as hasOtherContractIn } from '@/lib/contracts';

export interface PromoBlocsProps {
  isEligibleParrainage?: boolean;
}

const PromoBlocs = ({ isEligibleParrainage }: PromoBlocsProps) => {
  const hasOtherContract = hasOtherContractIn(useContractsData());

  const blocs = [
    {
      image: memoImg,
      title: 'Votre Mémo Véhicule',
      description: 'Retrouvez votre Mémo Véhicule Assuré partout et à tout moment !',
      link: '/mes-documents',
      buttonText: 'Télécharger',
      show: hasOtherContract,
    },
    {
      image: parrainageImg,
      title: 'Offre spéciale',
      description: 'Des récompenses pour vous et votre filleul à chaque parrainage !',
      link: '/mes-parrainages',
      buttonText: 'Je parraine',
      show: isEligibleParrainage,
    },
    {
      image: avantagesImg,
      title: 'Vos avantages',
      description: "Découvrez les avantages de nos partenaires et profitez d'offres exclusives",
      link: '/mes-avantages',
      buttonText: 'Je découvre',
      show: hasOtherContract,
    },
  ].filter((bloc) => bloc.show);

  if (blocs.length === 0) return null;

  return (
    <div data-tutorial="home-promoblocs" className="flex flex-col md:flex-row justify-center gap-6 py-6">
      {blocs.map((bloc, index) => (
        <Card key={index} className="group overflow-hidden flex flex-col hover:shadow-lg transition-shadow pt-0 md:w-1/3">
          <div className="aspect-[16/9] overflow-hidden">
            <img
              src={bloc.image}
              alt=""
              aria-hidden="true"
              className="w-full object-cover"
            />
          </div>
          <div className="px-6 py-4 flex flex-col flex-1">
            <p className="font-bold text-foreground text-base mb-1">{bloc.title}</p>
            <p className="text-sm text-muted-foreground mb-4 flex-1">{bloc.description}</p>
            <Button asChild variant="outline" className="w-full cursor-pointer py-4">
              <Link to={bloc.link} aria-label={`${bloc.buttonText} - ${bloc.title}`}>
                {bloc.buttonText}
              </Link>
            </Button>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default PromoBlocs;
